import React from 'react';
import PropTypes from 'prop-types';
import InteractiveMapSvg from './components/InteractiveMapSvg';

const UsaMap = (props) => {
  const interactiveMapClassList = `interactive-map tax-map ${props.page.interactive_map_gray_background ? 'light-gray-background' : ''}`;
  return (
    <div id="interactiveMap" className={interactiveMapClassList}>
      <div className="container">
        <div className="row">
          {props.headerTemplate}
          <div className="col-sm-12 col-md-10 col-md-offset-1">
            <InteractiveMapSvg
              {...props}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

UsaMap.defaultProps = {
  data: {
    interactive_map_gray_background: false,
  },
};

UsaMap.propTypes = {
  page: PropTypes.shape({
    document_name: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    interactive_map_gray_background: PropTypes.bool,
  }).isRequired,
  headerTemplate: PropTypes.element.isRequired,
};

export default UsaMap;

export { default as BusinessPlanLandingMap } from './containers/BusinessPlanLandingMap';



// WEBPACK FOOTER //
// ./src-react/UsaMap/index.jsx